export const getSearcherData = async (url, { BaseUrl  } = {})=>{
    if (!url || !BaseUrl) return;
    let finalUrl = url;
    if (!url.startsWith('http')) finalUrl = `${BaseUrl}${url}`;
    const response = await fetch(finalUrl);
    const data = await response.json();
    return data;
};
export const getSearcherModel = async (ajaxComponentData, { BaseUrl  } = {})=>{
    if (!BaseUrl) return;
    const url = `${BaseUrl}/homeshowcase/component/model`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(ajaxComponentData),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const data = await response.json();
    return data;
};

//# sourceMappingURL=service.js.map